import { render, staticRenderFns } from "./alarmInhibition.vue?vue&type=template&id=dc15d39c&scoped=true&"
import script from "./alarmInhibition.vue?vue&type=script&lang=js&"
export * from "./alarmInhibition.vue?vue&type=script&lang=js&"
import style0 from "./alarmInhibition.vue?vue&type=style&index=0&id=dc15d39c&prod&lang=scss&"
import style1 from "./alarmInhibition.vue?vue&type=style&index=1&id=dc15d39c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc15d39c",
  null
  
)

export default component.exports